export default __webpack_public_path__ + "static/media/alert-success.1cf7cc28.svg";